import {PKAutoPlayTypes} from '../types/auto-play-types';

const AutoPlayType: PKAutoPlayTypes = {
  TRUE: true,
  FALSE: false,
  IN_VIEW: 'inview'
};

export {AutoPlayType};
